module.exports = __webpack_public_path__ + "r-v3/img/ico_repeat_white.37c7ceed.svg";